(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .constant('paginationConstants', {
            'itemsPerPage': 10
        });
})();
